import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./SelectedProjects.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useWorkSection } from "../../../../context/WorkPageContext";
import { getSelectedWorkProjectsFromSection } from "../../../../services/contentApi";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { workProjects as fallbackProjects } from "../../../../data/workProjects";

function projectImageSrc(image) {
  if (!image) return "";
  return typeof image === "string" ? resolveMediaUrl(image) : image;
}

function ProjectTags({ services = [] }) {
  if (!services.length) return null;
  return (
    <div className="project__tags">
      {services.map((tag) => (
        <CmsText key={tag} content={tag} as="span" />
      ))}
    </div>
  );
}

const SelectedProjects = () => {
  const { section, loading } = useWorkSection("work-projects");

  const { title, projects } = useMemo(() => {
    if (section?.fields) {
      return getSelectedWorkProjectsFromSection(section);
    }
    return {
      title: "Selected projects",
      projects: fallbackProjects.slice(0, 3).map((p) => ({
        ...p,
        image: p.image,
        featured: true,
      })),
    };
  }, [section]);

  const [largeProject, ...smallProjects] = projects;

  if (loading && section == null) return null;
  if (!largeProject) return null;

  return (
    <section className="projects">
      <h2 className="projects__title">
        <CmsText content={title} as="span" />
      </h2>

      <div className="projects__grid">
        <Link
          to={`/projectdetail/${largeProject.slug}`}
          className="project project--large"
        >
          <div className="project__image">
            <img src={projectImageSrc(largeProject.image)} alt="" />
          </div>

          <div className="project__content">
            <CmsText
              content={largeProject.tag || "Industry"}
              as="span"
              className="project__industry"
            />

            <h3>
              <CmsText content={largeProject.title} as="span" />
              <span className="arrow">↗</span>
            </h3>

            <RichTextContent content={largeProject.desc} />

            <ProjectTags services={largeProject.services} />
          </div>
        </Link>

        <div className="projects__right">
          {smallProjects.map((project) => (
            <Link
              key={project.slug}
              to={`/projectdetail/${project.slug}`}
              className="project project--small"
            >
              <div className="project__image">
                <img src={projectImageSrc(project.image)} alt="" />
              </div>

              <div className="project__info">
                <CmsText
                  content={project.tag || "Industry"}
                  as="span"
                  className="project__industry"
                />

                <h4>
                  <CmsText content={project.title} as="span" />
                </h4>

                <RichTextContent content={project.desc} />

                <ProjectTags services={project.services} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SelectedProjects;
